import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import GET_SHOPPING_LIST_COUNT from '../operations/queries/get-shopping-list-count.js';

const useGetShoppingListCount = (wishlistId, clearWishlist)=>{
    var ref1;
    const { locale  } = useIntl();
    const [trigger, { data: data1 , refetch  }] = useLazyQuery(GET_SHOPPING_LIST_COUNT, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        fetchPolicy: 'no-cache',
        onCompleted: (data)=>{
            var ref;
            /*
        There are scenarios where CommerceTools removes a shopping list/wishlist (because of its storage policy/limit),
        but then the local storage still has the wishlist id. To prevent this, we need to filter on a BE failure
        and clear the local storage.
      */ if (((ref = data.shoppinglistById.failure) === null || ref === void 0 ? void 0 : ref.__typename) === 'ShoppinglistNotFoundFailure') {
                clearWishlist === null || clearWishlist === void 0 ? void 0 : clearWishlist();
            }
        }
    });
    React.useEffect(()=>{
        if (wishlistId) {
            trigger({
                variables: {
                    shoppinglistId: wishlistId
                }
            });
        }
    }, [
        trigger,
        wishlistId
    ]);
    useWishlistId(refetch);
    return {
        itemsCount: (ref1 = data1 === null || data1 === void 0 ? void 0 : data1.shoppinglistById.shoppinglist) === null || ref1 === void 0 ? void 0 : ref1.itemsCount
    };
};

export { useGetShoppingListCount };
//# sourceMappingURL=use-get-shopping-list-count.js.map
